// extracted by mini-css-extract-plugin
export default {"section":"photos_section__b+wSk","gridCard":"photos_gridCard__j3ZmY","img":"photos_img__AfqvB"};